import React, { useState, useEffect, useContext } from 'react';
import { GlobalContext } from '../../context/GlobalState';

import * as Styled from './style';

import { TeamMoodRow } from '../../components';
import { getUserId } from '../../services/firebaseInit';
import { createMood, updateMood } from '../../services/teamMoods';
import { updateRetrospective } from '../../services/retrospectives';

function MoodBoardContainer() {
  const { retrospective, teamMood: moods } = useContext(GlobalContext);
  const [mood, setMood] = useState();
  const [teamMoodQuestions, setTeamMoodQuestions] = useState([]);

  const userId = getUserId();
  const currentMood = moods.find((mo) => mo.participant === userId);
  useEffect(() => {
    if (mood !== currentMood) setMood(currentMood);

    return () => {
      setMood();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moods]);

  useEffect(() => {
    if (teamMoodQuestions !== retrospective.teamMoodQuestions) {
      setTeamMoodQuestions(retrospective.teamMoodQuestions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [retrospective.teamMoodQuestions]);

  useEffect(() => {
    if (
      mood &&
      mood.participant &&
      mood !== moods.find((m) => m.id === mood.id)
    )
      updateMood(retrospective.id, mood.id, { ...mood });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mood]);
  const handleMood = async (index, emotion) => {
    let m = { ...mood };
    if (!m || !m.questions) {
      const questions = retrospective.teamMoodQuestions.map((q) => ({
        question: q,
        emotion: '',
      }));
      m = await createMood(retrospective.id, questions, userId);
    }

    m.questions[index].emotion = emotion;

    setMood({ ...m });
    if (!retrospective.moodStarted)
      updateRetrospective(retrospective.id, { moodStarted: true });
  };

  return (
    <Styled.Grid>
      {teamMoodQuestions.map((q, index) => (
        <TeamMoodRow
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          question={q}
          mood={
            mood && mood.questions
              ? mood.questions?.find((question) => question.question === q)
                  .emotion
              : null
          }
          index={index}
          handleMood={handleMood}
        />
      ))}
    </Styled.Grid>
  );
}

export default MoodBoardContainer;
